import React from 'react'
import { SUI, IconButton } from 'shared/ui'

import Dropdown from './Dropdown'

export default function IconDropdown({ ticketId, iconSize = 14, ...rest }) {
  return (
    <SUI>
      <Dropdown
        {...rest}
        hotkey="s"
        id="snoozeDropdown"
        icon={null}
        trigger={
          <IconButton
            color="berry"
            name="snooze"
            svg
            size="small"
            iconSize={iconSize}
            tooltip="Snooze [s]"
          />
        }
      />
    </SUI>
  )
}
